import React from "react";

function About() {
  return (
    <>
      <div className="about">
        <h1 className="water-brush mt-5 ps-2 title">About Me</h1>
        <div className="row">
          <div className="col-lg-8 col-sm-8">
            <p className="px-4 text-justify">
              Greeting,
              <br />I recently received my Bachelor of Science in Information
              Technology. Throughout my four years of study, I devoted the
              majority of my time to computer programming. I explored some
              programming languages in that time and am now able to apply
              knowledge and develop simple projects to improve the skills that I
              post on my GitHub repositories.
            </p>
          </div>

          <div className="col-lg-4 col-sm-4">
            <h2 className="water-brush my-2 ps-2">
              <i className="bx bx-wrench"></i> Tools / Technology
            </h2>

            <div className="apply-padding">
            <img
              src="https://skillicons.dev/icons?i=html"
              className="m-1"
              alt=""
            />
            <img
              src="https://skillicons.dev/icons?i=css"
              className="m-1"
              alt=""
            />
            <img
              src="https://skillicons.dev/icons?i=bootstrap"
              className="m-1"
              alt=""
            />
            <img
              src="https://skillicons.dev/icons?i=js"
              className="m-1"
              alt=""
            />
            <img
              src="https://skillicons.dev/icons?i=jquery"
              className="m-1"
              alt=""
            />
            <img
              src="https://skillicons.dev/icons?i=react"
              className="m-1"
              alt=""
            />
            <img
              src="https://skillicons.dev/icons?i=php"
              className="m-1"
              alt=""
            />
            <img
              src="https://skillicons.dev/icons?i=laravel&theme=light"
              className="m-1"
              alt=""
            />
            <img
              src="https://skillicons.dev/icons?i=mysql"
              className="m-1"
              alt=""
            />
            <img
              src="https://skillicons.dev/icons?i=java"
              className="m-1"
              alt=""
            />
            <img
              src="https://skillicons.dev/icons?i=git"
              className="m-1"
              alt=""
            />
            <img
              src="https://skillicons.dev/icons?i=nodejs"
              className="m-1"
              alt=""
            />
            <img
              src="https://skillicons.dev/icons?i=vscode"
              className="m-1"
              alt=""
            />
            <img
              src="https://skillicons.dev/icons?i=powershell"
              className="m-1"
              alt=""
            />
          </div>
        </div>
      </div>
      </div>
    </>
  );
}

export default About;
